import { defaultCollaboratorCategoryOptions } from '@/lib/collaboratorCategories';

export const baseCollaboratorOrganizationTypes = defaultCollaboratorCategoryOptions['Production & Talent Services'] || [];
export const instituteAcademyTypes = defaultCollaboratorCategoryOptions['Institutes & Academies'] || [];
export const studioVenueTypes = defaultCollaboratorCategoryOptions['Studios & Venues'] || [];

export const collaboratorOrganizationTypes = [
  ...baseCollaboratorOrganizationTypes,
  ...instituteAcademyTypes,
  ...studioVenueTypes,
  'Other',
];

export const isInstituteAcademyType = (type = '') =>
  instituteAcademyTypes.includes(String(type || '').trim());

export const isStudioVenueType = (type = '') =>
  studioVenueTypes.includes(String(type || '').trim());

export const getCollaboratorVertical = (type = '') => {
  if (isInstituteAcademyType(type)) return 'institutes';
  if (isStudioVenueType(type)) return 'studios';
  return 'collaborators';
};
